import * as React from 'react';
import { graphql } from 'gatsby';

import Layout from '../layout/layout';
import HomepageHero from '../modules-static/homepage-hero';
import HomepageIntro from '../modules-static/homepage-intro';
import PageBuilder from '../components/page-builder';

const IndexPage = ({ data }) => {
	const page = data.page;
	return (
		<Layout page={{ slug: "/", breadcrumb: [], name: "Home", }}>
			<main className='sb-jungle'>
				<HomepageHero />
				<HomepageIntro />
				<PageBuilder data={page.builder} />
			</main>
		</Layout>
	);
};

export default IndexPage;

export const query = graphql`
	query {
		page: datoCmsHomepage {
			builder {
				__typename
				... on DatoCmsText {
					...TextBlock
				}
				... on DatoCmsCalloutText {
					...CalloutText
				}
				... on DatoCmsSingle {
					...Single
				}
				... on DatoCmsImageGrid {
					...ImageGrid
				}
				... on DatoCmsServicesBlock {
					...ServicesBlock
				}
				... on DatoCmsMediaContent {
					...MediaContent
				}
				... on DatoCmsMediaContentGrid {
					...MediaContentGrid
				}
				... on DatoCmsCarousel {
					...ImageCarousel
				}
				... on DatoCmsClientCarousel {
					...ClientCarousel
				}
				... on DatoCmsPrincipleCallout {
					...PrincipleCallout
				}
				... on DatoCmsResult {
					...Results
				}
				... on DatoCmsErgCarousel {
					...ErgCarousel
				}
				... on DatoCmsSubbrand {
					...SubbrandCallout
				}
				... on DatoCmsWorkCarousel {
					...WorkCarousel
				}
				... on DatoCmsRecentInsight {
					...RecentInsight
				}
			}
		}
	}
`;
